export default "__VITE_PUBLIC_ASSET__e4aa5fad__"